/**
 * Global viewport breakpoints for layout (mobile vs desktop shell).
 *
 * Aligns with NavigationBar / AppHome: "mobile layout" when the viewport width
 * is at most VIEWPORT_MOBILE_MAX_PX (inclusive). Use useIsMobileLayout() from
 * hooks/useMediaQuery.js instead of reading window.innerWidth in components.
 *
 * Dedicated routes such as /inventory/mobile are product flows, not replaced by this.
 */
export const VIEWPORT_MOBILE_MAX_PX = 768;

/** CSS media query string — matches when width <= VIEWPORT_MOBILE_MAX_PX */
export const MOBILE_LAYOUT_MEDIA_QUERY = `(max-width: ${VIEWPORT_MOBILE_MAX_PX}px)`;

/**
 * Footer / inventory compact layout (was innerWidth <= 991.98).
 * Differs from MOBILE_LAYOUT_MEDIA_QUERY (768) on purpose.
 */
export const COMPACT_FOOTER_MEDIA_QUERY = '(max-width: 991.98px)';
